import React from "react";
import { Card, CardContent, Grid, Skeleton, Typography } from "@mui/material";

import { type ChartDataSet } from "../../charts/getChartConfig.ts";
import DoughnutPMI from "../../charts/DoughnutPMI.tsx";

export default function DemographicsChart({
  title,
  config,
  chartClass,
}: {
  title: string;
  config: ChartDataSet | undefined;
  chartClass?: string;
}) {
  return (
    <Grid size={{ md: 12, lg: 6 }}>
      <Card className="demographic-breakdown-card">
        <CardContent>
          <Typography
            className="card-title"
            align="left"
            variant="subtitle1"
            gutterBottom
          >
            {title}
          </Typography>
          <div className={chartClass}>
            {!config && (
              <div className="skeleton">
                <Skeleton
                  variant="circular"
                  animation="wave"
                  width="144px"
                  height="144px"
                />
                <div className="skeleton-row">
                  <Skeleton animation="wave" width="60px" />
                  <Skeleton animation="wave" width="60px" />
                  <Skeleton animation="wave" width="60px" />
                  <Skeleton animation="wave" width="60px" />
                </div>
              </div>
            )}
            {config && <DoughnutPMI data={config} />}
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}
